// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'bootstrap'
import VueResource from 'vue-resource'

// import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery.easing'
import 'font-awesome/css/font-awesome.css'
// import Toastr from 'vue-toastr'
// require('vue-toastr/dist/vue-toastr.css')
// require('vue-toastr/src/vue-toastr.less')
Vue.config.productionTip = false
Vue.use(VueResource)
Vue.http.headers.common['Accept'] = 'application/json'

// Vue.component('vue-toastr', Toastr)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store,
  template: '<App/>',
  components: {App}
})
window.Vue = Vue



// WEBPACK FOOTER //
// ./src/main.js